import React from "react";
import { Drawer } from "antd";
import ExportCSVReport from "../../../../components/ExportCSVReport";

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  const viewData = openUpdateData?.response
    ? JSON.parse(openUpdateData?.response)
    : null;

  const tableArray = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data.records)
      ? data.records
      : [data.records];

    return (
      <>
        <thead>
          <tr>
            <th>Phone Number</th>
            <th>Network Type</th>
            <th>Is Ported</th>
            <th>State</th>
            <th>Payment Type</th>
            <th>Service Type</th>
            <th>Subscription Type</th>
            <th>Client Name</th>
            <th>Client Id</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.phone_number}</td>
                <td>{item.network_type}</td>
                <td>{`${item.is_ported}`}</td>
                <td>{item.state}</td>
                <td>{item.payment_type}</td>
                <td>{item.service_type}</td>
                <td>{item.subscription_type}</td>
                <td>{item.client_name}</td>
                <td>{item.client_id}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      footer={
        viewData ? (
          <div className="text-right">
            <ExportCSVReport
              elements={viewData.records}
              reportName={`number-attributes-${openUpdateData.number_type}-${Date.now()}`}
              label={true}
            />
          </div>
        ) : (
          false
        )
      }
      className="addModal"
      title={`View Report`}
    >
      <table className="reportTable" width={"100%"}>
        {tableArray(viewData)}
      </table>
      {/* {viewData?.length > 0 ? viewData.map((item: any) => monthlyData(item)) : null} */}
    </Drawer>
  );
};

export default ViewReport;
